// src/components/ui/elements/SearchableList.tsx
import React, { useState } from 'react';
import { Search } from 'lucide-react';

export interface SearchableItem {
  id: string;
  label: string;
  // possibilité d'ajouter d'autres champs selon besoin
}

interface SearchableListProps<T extends SearchableItem> {
  items: T[];
  renderItem: (item: T, isSelected: boolean) => React.ReactNode;
  onSelect: (item: T) => void;
  searchPlaceholder?: string;
  selectedId?: string;
  filterFn?: (item: T, searchTerm: string) => boolean;
  emptyMessage?: string;
  maxHeight?: string;
}

export const SearchableList = <T extends SearchableItem>({
  items,
  renderItem,
  onSelect,
  searchPlaceholder = "Rechercher...",
  selectedId,
  filterFn,
  emptyMessage = "Aucun résultat",
  maxHeight = "max-h-60",
}: SearchableListProps<T>) => {
  const [searchTerm, setSearchTerm] = useState('');

  const defaultFilter = (item: T, term: string) =>
    item.label.toLowerCase().includes(term.toLowerCase());

  const filteredItems = items.filter(item =>
    (filterFn || defaultFilter)(item, searchTerm)
  );

  return (
    <div>
      <div className="p-2 border-b border-gray-200">
        <div className="relative">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400" />
          <input
            type="text"
            placeholder={searchPlaceholder}
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="w-full pl-9 pr-3 py-1.5 text-sm border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary/50 text-black placeholder-gray-500"
            autoFocus
          />
        </div>
      </div>
      <div className={`${maxHeight} overflow-y-auto py-2`}>
        {filteredItems.length > 0 ? (
          filteredItems.map(item => (
            <div key={item.id} onClick={() => onSelect(item)}>
              {renderItem(item, item.id === selectedId)}
            </div>
          ))
        ) : (
          <div className="px-4 py-3 text-sm text-gray-500 text-center">{emptyMessage}</div>
        )}
      </div>
    </div>
  );
};